// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__yKqIL","nav":"menu_nav__GchOT","on":"menu_on__NikJu","logo":"menu_logo__i7nuQ"};